import {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  clampSliderIndex,
} from "../utils/tournamentProductUtils";

export default function useTournamentHeroSlider({
  slides = [],
  interval = 6500,
} = {}) {
  const [currentIndex, setCurrentIndex] =
    useState(0);

  const [paused, setPaused] =
    useState(false);

  const reduceMotion =
    useMemo(() => {
      if (
        typeof window ===
          "undefined" ||
        !window.matchMedia
      ) {
        return false;
      }

      return window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches;
    }, []);

  const goTo = useCallback(
    (nextIndex) => {
      setCurrentIndex(
        clampSliderIndex(
          nextIndex,
          slides.length,
        ),
      );
    },
    [slides.length],
  );

  const next = useCallback(() => {
    setCurrentIndex(
      (current) =>
        clampSliderIndex(
          current + 1,
          slides.length,
        ),
    );
  }, [slides.length]);

  const previous = useCallback(() => {
    setCurrentIndex(
      (current) =>
        clampSliderIndex(
          current - 1,
          slides.length,
        ),
    );
  }, [slides.length]);

  useEffect(() => {
    if (
      slides.length <= 1 ||
      paused ||
      reduceMotion
    ) {
      return undefined;
    }

    const timerId =
      window.setInterval(() => {
        setCurrentIndex(
          (current) =>
            clampSliderIndex(
              current + 1,
              slides.length,
            ),
        );
      }, interval);

    return () => {
      window.clearInterval(timerId);
    };
  }, [
    interval,
    paused,
    reduceMotion,
    slides.length,
  ]);

  useEffect(() => {
    if (
      currentIndex >=
      slides.length
    ) {
      setCurrentIndex(0);
    }
  }, [
    currentIndex,
    slides.length,
  ]);

  return {
    currentIndex,

    currentSlide:
      slides[currentIndex] ||
      slides[0] ||
      null,

    paused,

    setPaused,
    goTo,
    next,
    previous,
  };
}